<div class="cipx-form-container w-full">
  <cipx-scrollable-content #shoppingCartScroll [removeOverflowOnMobile]="true">

    @switch (currentStep()) {
      @case (ShoppingCartStep.CART) {
        @if (items().length === 0) {
          <div class="empty-cart">
            <mat-icon>shopping_cart</mat-icon>
            <h2>Your shopping cart is empty</h2>
            <p>Add items to your cart to get started.</p>
          </div>
        }

        @if (items().length > 0) {
           <!-- Cart Items -->
           <div class="space-y-4">
             @for (item of items(); track item.id) {
               @switch (item.type) {
                 @case (CartItemType.QUOTE_REQUEST) {
                   <cipx-quote-request-cart-item
                     class="cipx-shopping-cart-item"
                     [item]="item"
                     [useAccordionComponent]="true"
                     [toggleAccordion]="shouldExpandAccordion()"
                     (removeItem)="onRemoveItem($event)"
                     (updateQuantity)="onUpdateQuantity($event)"
                     (viewDetails)="onViewDetails($event)"
                     (declineQuote)="onDeclineQuote($event)"
                     (itemUpdated)="onItemUpdated($event)"
                     (sendMessageFromDrawer)="sendMessageFromDrawer($event)"></cipx-quote-request-cart-item>
                 }
                 @case (CartItemType.RIDER) {
                   <cipx-rider-cart-item
                     class="cipx-shopping-cart-item"
                     [item]="item"
                     (removeItem)="onRemoveItem($event)"
                     (updateQuantity)="onUpdateQuantity($event)"
                     (viewDetails)="onViewDetails($event)"></cipx-rider-cart-item>
                 }
                 @default {
                   <!-- Fallback to generic item component -->
                   <cipx-shopping-cart-item
                     [item]="item"
                     [useAccordionComponent]="true"
                     [toggleAccordion]="shouldExpandAccordion()"
                     (removeItem)="onRemoveItem($event)"
                     (updateQuantity)="onUpdateQuantity($event)"
                     (viewDetails)="onViewDetails($event)"></cipx-shopping-cart-item>
                 }
               }
             }
           </div>
          <div class="mt-4">
            <!-- Cart Summary -->
            <cipx-cart-summary
              [items]="items()"
              title="Cart Summary"
              [showItemDetails]="true">
            </cipx-cart-summary>
          </div>
        }
      }

      @case (ShoppingCartStep.PAYMENT) {
        <!-- Payment Step Content -->
        <div class="space-y-6">
          <!-- Order Summary -->
          <cipx-cart-summary
            [items]="items()"
            title="Order Summary"
            [showItemDetails]="true">
          </cipx-cart-summary>

          <!-- Payment Form -->
          <cipx-shopping-cart-payment
            [items]="items()"
            (paymentProcessed)="onPaymentProcessed($event)"
            (formValid)="onPaymentFormValidityChange($event)">
          </cipx-shopping-cart-payment>
        </div>
      }

      @case (ShoppingCartStep.CONFIRMATION) {
        <!-- Confirmation Step Content -->
        <cipx-shopping-cart-confirmation
          [items]="items()"
          [orderNumber]="orderNumber"
          (purchaseAnother)="onPurchaseAnother()"
          (purchaseAnotherSimilar)="onPurchaseAnotherSimilar()"
          (requestQuote)="onRequestQuote()"
          (viewBonds)="onViewBonds()">
        </cipx-shopping-cart-confirmation>
      }
    }

    <cipx-action-bar [sticky]="true" [removeStickyOnMobile]="true" justify="end">
      @if (showCancelButton) {
        <cipx-cancel-button (buttonClick)="onCancel()"> {{ currentStep() === ShoppingCartStep.CONFIRMATION ? 'Close' : 'Cancel' }}</cipx-cancel-button>
      }
      @if (isSingleRenewalDirectBill()) {
        <div class="cipx-split-button">
          <button
            mat-flat-button
            color="primary"
            class="cipx-split-button__primary"
            [disabled]="!canProceed()"
            (click)="openDirectBillDialog()">
            Proceed to Payment
          </button>
          <button
            mat-flat-button
            color="primary"
            class="cipx-split-button__toggle"
            #payHereTrigger="matMenuTrigger"
            [disabled]="!canProceed()"
            [matMenuTriggerFor]="payHereMenu"
            aria-label="More payment options">
            <mat-icon
              class="cipx-split-button__chevron"
              [class.cipx-split-button__chevron--open]="payHereTrigger?.menuOpen"
              svgIcon="heroicons_outline:chevron-down"></mat-icon>
          </button>
          <mat-menu #payHereMenu="matMenu">
            <button mat-menu-item (click)="handlePrimaryAction()">Pay here instead</button>
          </mat-menu>
        </div>
      } @else {
        <cipx-primary-button
          [disabled]="!canProceed()"
          [icon]="'heroicons_outline:chevron-right'"
          [iconPosition]="'append'"
          (buttonClick)="handlePrimaryAction()">
          {{ getActionButtonText() }}
        </cipx-primary-button>
      }
    </cipx-action-bar>
  </cipx-scrollable-content>
</div>
